<template>

    <div class="copybox" :class="classes">
        <div class="copybox-body" :style="bodyStyles">
            <v-button size="xs" theme="white" v-tooltip="{ 'content': $t('labels.copy') }" @click.native="copy">
                <i v-if="!copied" class="fas fa-clipboard"></i>
                <i v-else class="fas fa-clipboard-check text-success"></i>
            </v-button>
            <span ref="textToCopy"><slot></slot></span>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .copybox {
        display: table;
        table-layout: fixed;
        width: 100%;
        word-wrap: break-word;
        &.copybox-bordered {
            border: 1px solid $color-rule;
            border-radius: 3px;
        }
        &.copybox-primary {
            border: 2px solid $color-primary;
            border-radius: 9999px;
            .copybox-body {
                align-items: center;
                display: flex;
                flex-direction: row-reverse;
                padding: 12px 20px 12px 20px;
                button {
                    margin: 0;
                    position: static;
                }
                span {
                    flex: 1;
                    min-width: 0;
                }
            }
        }
        .copybox-body {
            @include font-medium(14px);
            color: $color-text;
            line-height: 1.4em;
            min-height: 50px;
            min-width: 100px;
            padding: 12px 50px 12px 15px;
            position: relative;
            text-align: left;
            white-space: normal;
            button {
                margin: 5px;
                position: absolute;
                right: 0;
                top: 0;
            }
        }
    }

</style>

<script>

import copy from 'copy-to-clipboard';

export default {

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            type: String,
        },
        bordered: {
            type: Boolean,
            default: true,
        },
        html: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String,
            default: 'default',
        },
    },

    data() {
        return {
            copied: this.active,
        }
    },

    computed: {

        bodyStyles() {
            if (!this.backgroundColor) {
                return {};
            }

            return {
                'background-color': this.backgroundColor,
            };
        },

        classes() {
            return {
                'copybox-bordered': this.bordered && this.theme === 'default',
                'copybox-primary': this.bordered && this.theme === 'primary',
            };
        },

    },

    watch: {

        active(val) {
            this.copied = val;
        },

    },

    methods: {

        copy() {
            let copied = copy(this.$refs.textToCopy.textContent, {
                format: this.html ? 'text/html' : 'text/plain',
                onCopy: this.onCopy,
            });
            if (!copied) {
                this.$store.commit('setAlertError', this.$t('messages.cannot_copy'));
            }
        },

        onCopy() {
            this.$emit('input', this.$refs.textToCopy.textContent);
            this.$store.commit('setAlertSuccess', this.$t('messages.copied'));
            this.copied = true;
        },

    },

}

</script>
